import React from "react";

const Waterpolo = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      className={className}
    >
      <g clip-path="url(#clip0_14545_80170)">
        <path d="M7.71429 7.70021C7.24286 7.70021 6.85714 8.08565 6.85714 8.55674V11.1349H17.1429V8.55674C17.1429 8.08565 16.7571 7.70021 16.2857 7.70021H7.71429ZM21.06 4.12848L18.2657 6.92934C18.6343 7.37473 18.8571 7.94004 18.8571 8.55674V15.4347C18.8571 16.0514 18.6257 16.6167 18.2657 17.0621L21.06 19.863C22.8857 17.7473 24 15.0064 24 11.9914C24 8.97645 22.8857 6.23555 21.06 4.11991V4.12848ZM7.26 6.02998C7.40571 6.00428 7.56 5.98715 7.71429 5.98715H11.1429V0.0085653C8.47714 0.197002 6.06 1.2591 4.15714 2.91221L7.26 6.02998ZM12.8571 0.0085653V5.97859H16.2857C16.44 5.97859 16.5943 5.99572 16.74 6.02141L19.8429 2.90364C17.94 1.25054 15.5143 0.188437 12.8571 0V0.0085653ZM11.1429 23.9914V18.0214H7.71429C7.56 18.0214 7.40571 18.0043 7.26 17.9786L4.15714 21.0964C6.06 22.7495 8.48571 23.8116 11.1429 24V23.9914ZM7.71429 16.2998H16.2857C16.7571 16.2998 17.1429 15.9143 17.1429 15.4433V12.8651H6.85714V15.4433C6.85714 15.9143 7.24286 16.2998 7.71429 16.2998ZM5.73429 17.0621C5.36571 16.6167 5.14286 16.0514 5.14286 15.4347V8.55674C5.14286 7.94004 5.37429 7.37473 5.73429 6.92934L2.94 4.12848C1.11429 6.24411 0 8.98501 0 12C0 15.015 1.11429 17.7559 2.94 19.8715L5.73429 17.0707V17.0621ZM16.74 17.97C16.5943 17.9957 16.44 18.0128 16.2857 18.0128H12.8571V23.9829C15.5229 23.7944 17.94 22.7323 19.8429 21.0792L16.74 17.9615V17.97Z" />
      </g>
    </svg>
  );
};

export default Waterpolo;
